import { render, staticRenderFns } from "./PrintPhieuThayDoiThongTin.vue?vue&type=template&id=1db8e498&"
import script from "./PrintPhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
export * from "./PrintPhieuThayDoiThongTin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports